<div class="create-first-shipment-container">
  <div class="create-first-shipment-container__description">
    <div class="header">
      {{ "LCL_SHIPMENT.DASHBOARD.EMPTY_DASHBOARD_HEADER" | translate }}
    </div>
    <div class="sub-header">{{ "LCL_SHIPMENT.DASHBOARD.EMPTY_DASHBOARD_SUBHEADER" | translate }}</div>
    <div class="d-flex">
      <div class="get-quote-button" [routerLink]="['/lcl-shipping', 'new']">
        {{ "BUTTON.GET_A_QUOTE" | translate }}
      </div>
    </div>
  </div>
  <div class="shipment-image-container">
    <img src="assets/icons/shipment.svg" />
  </div>
</div>
